/**
 * nav-icons.ts — Carbon-ikonene til sidemenyen (øverste nivå), slått opp på NavIconName fra lib/navigation.ts
 */

import { Api, Bullhorn, Car, Customer, Dashboard, Folders, Logout, UserAdmin, UserSettings } from '@carbon/icons-react';
import type { NavIconName } from '@/lib/navigation';

export const NAV_ICONS: Record<NavIconName, typeof Dashboard> = {
  dashboard: Dashboard,
  files: Folders,
  rental: Car,
  plug: Api,
  ads: Bullhorn,
  crm: Customer,
  admin: UserAdmin,
  settings: UserSettings,
  logout: Logout,
};
